const KEY = 'gg_attribution';
const PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid'];

// First-touch landing/campaign attribution for this browser session (no personal data).
export const captureAttribution = () => {
  try {
    const q = new URLSearchParams(window.location.search);
    const hasCampaign = PARAMS.some((p) => q.get(p));
    if (sessionStorage.getItem(KEY) && !hasCampaign) return;
    const ref = document.referrer && !document.referrer.startsWith(window.location.origin) ? document.referrer : '';
    const data = { landing_path: window.location.pathname, referrer: ref, captured_at: new Date().toISOString() };
    PARAMS.forEach((p) => { if (q.get(p)) data[p] = q.get(p).slice(0, 200); });
    sessionStorage.setItem(KEY, JSON.stringify(data));
  } catch { /* storage unavailable */ }
};

export const getAttribution = () => {
  try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch { return null; }
};
